import { render, staticRenderFns } from "./help-center.vue?vue&type=template&id=38810b1a&scoped=true&"
import script from "./help-center.vue?vue&type=script&lang=js&"
export * from "./help-center.vue?vue&type=script&lang=js&"
import style0 from "./help-center.vue?vue&type=style&index=0&id=38810b1a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38810b1a",
  null
  
)

export default component.exports